export default __webpack_public_path__ + "static/media/numberFive.4955d2d7.svg";